import {NavigationMenuInlineAddParams, NavigationMenuInlineAddType} from "../../@types";

export default (onAddInline: {
    (inlineAddType: NavigationMenuInlineAddType, params?: NavigationMenuInlineAddParams): void
}): any[] => {

    const options: any = []

    options.push({
        icon    : 'i5-todo-list',
        label   : 'Checklist',
        onClick : ()=>{onAddInline(NavigationMenuInlineAddType.TODOS)}
    })

    options.push({
        icon    : 'i5-goals',
        label   : 'Goals',
        onClick : ()=>{onAddInline(NavigationMenuInlineAddType.GOALS)}
    })

    options.push({
        icon    : 'i5-files-light',
        label   : 'Files',
        onClick : ()=>{onAddInline(NavigationMenuInlineAddType.FILES)}
    })


    options.push({
        icon    : 'i5-meeting-light',
        label   : 'Meetings',
        onClick : ()=>{onAddInline(NavigationMenuInlineAddType.MEETINGS)}
    })

    options.push({
        icon    : 'i5-expenses-light',
        label   : 'Expenses',
        onClick : ()=>{onAddInline(NavigationMenuInlineAddType.EXPENSES)}
    })

    options.push({
        icon    : 'i5-discussion-light',
        label   : 'Chats',
        onClick : ()=>{onAddInline(NavigationMenuInlineAddType.CHATS)}
    })

    options.push({type: 'separator'})

    options.push({
        icon    : 'i5-tasks',
        label   : 'Task List',
        onClick : ()=>{onAddInline(NavigationMenuInlineAddType.TASK_LIST)}
    })

    options.push({
        icon    : 'i5-board',
        label   : 'Task Board',
        onClick : ()=>{onAddInline(NavigationMenuInlineAddType.TASK_BOARD)}
    })



    // templatesOptions.push({
    //     icon    : 'i5-templates',
    //     label   : 'Templates library',
    //     onClick : ()=>onAddFromLibrary()
    // })
    //
    return options
}
